<template>
    <div>
        <form ref="form">
            <div class="flex items-center py-md" @click="toggled = ! toggled">
                <checkbox-input
                    v-model="completed"
                    v-tooltip.top.start="unableToCompleteMessage"
                    :disabled="! selectedOption || ! task.can_be_completed"
                    @toggle="toggleCompleted"
                >
                    {{ task.body }}
                </checkbox-input>

                <div class="ml-auto flex items-center">
                    <task-completed-by
                        :task="task"
                        class="mr-md"
                    />

                    <font-awesome-icon
                        v-if="toggled"
                        icon="chevron-up"
                    />
                    <font-awesome-icon
                        v-else
                        icon="chevron-down"
                    />
                </div>
            </div>

            <div v-show="toggled" class="pb-md">
                <select-input
                    v-model="selectedOption"
                    class="w-full"
                    name="choice"
                    :options="task.data.options"
                    :disabled="disabled"
                    placeholder="Välj alternativ"
                />
            </div>
        </form>
    </div>
</template>

<script>
    import BaseType from './BaseType';

    export default {
        extends: BaseType,
        props: {
            disabled: {
                required: false,
                type: Boolean,
                default: false,
            },
        },
        data() {
            return {
                selectedOption: this.task.data.choice || '',
                toggled: false,
            };
        },
        watch: {
            selectedOption() {
                // Updates the option when it's already completed
                if (this.completed) {
                    this.complete();
                }
            },
        },
        methods: {
            toggleCompleted(isChecked) {
                if (! isChecked) {
                    return this.uncomplete();
                }

                this.complete();
            },
            async complete() {
                if (this.disabled) {
                    return;
                }

                this.completed = await this.completeTask({ choice: this.selectedOption });
                if (! this.completed) {
                    this.error = 'Kunde inte spara';
                }
            },
            async uncomplete() {
                if (this.disabled) {
                    return;
                }

                this.completed = ! await this.unCompleteTask();
                if (this.completed) {
                    this.error = 'Kunde inte ångra';
                }
            },
        },
    };
</script>